import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b09a22c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { compartirSistemaAleman } from "@/composables/useSistemaAleman";
import { EstaJugandoDTO, PartidaTorneoDTO } from "@/interfaces/Partidas";
import { computed } from "vue";
import { FORMATO_COPA, FORMATO_LIGA } from "@/Constant/FormatoTorneo";
import { etiquetaPartidaCopa } from "@/utils/cuadroCopa";
import CardPartidaGestion from "@/components/GestionTorneos/CardPartidaGestion.vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalPartidasActivas',
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  estaJugando: {
    type: Object as () => EstaJugandoDTO,
    default: () => ({}),
  },
  idUsuario: {
    type: Number,
    required: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
// Con el sistema alemán, las partidas enseñan también los puntos que dan
compartirSistemaAleman(() => props.estaJugando.classificationType);

// eslint-disable-next-line no-undef
const emit = __emit;

const modelValueProxy = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit("update:modelValue", val),
});

const esLiga = computed(
  () => props.estaJugando?.formatoTorneo === FORMATO_LIGA
);
// En la copa, por su grupo y jornada o su ronda del cuadro
const esCopa = computed(
  () => props.estaJugando?.formatoTorneo === FORMATO_COPA
);

// «Ronda 2 · Mesa 3»; sin número de mesa (con partidas de dos eventos el mismo día) solo la ronda
const etiquetaRonda = (partida: PartidaTorneoDTO) =>
  partida.numeroMesa
    ? `Ronda ${partida.numeroRonda} · Mesa ${partida.numeroMesa}`
    : `Ronda ${partida.numeroRonda}`;

// La ronda en juego arriba: las ya jugadas del día quedan debajo
const partidasOrdenadas = computed(() =>
  [...(props.estaJugando?.partidas ?? [])].sort((a, b) => (b.numeroRonda ?? 0) - (a.numeroRonda ?? 0))
);

function close() {
  emit("update:modelValue", false);
}

function editarPartidaPJ(partida: PartidaTorneoDTO) {
  if (
    partida.idCapitan1 === props.idUsuario ||
    partida.idCapitan2 === props.idUsuario
  ) {
    if (
      partida.idCapitan1 === props.idUsuario &&
      (partida.partidaValidadaUsuario1 === false ||
        partida.partidaValidadaUsuario1 === null)
    ) {
      return true;
    } else if (
      partida.idCapitan2 === props.idUsuario &&
      (partida.partidaValidadaUsuario2 === false ||
        partida.partidaValidadaUsuario2 === null)
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    if (
      partida.idUsuario1 === props.idUsuario &&
      (partida.partidaValidadaUsuario1 === false ||
        partida.partidaValidadaUsuario1 === null)
    ) {
      return true;
    } else if (
      partida.idUsuario2 === props.idUsuario &&
      (partida.partidaValidadaUsuario2 === false ||
        partida.partidaValidadaUsuario2 === null)
    ) {
      return true;
    } else {
      return false;
    }
  }
}

function soloValidarPJ(partida: PartidaTorneoDTO) {
  if (
    partida.idCapitan1 === props.idUsuario ||
    partida.idCapitan2 === props.idUsuario
  ) {
    if (
      partida.idCapitan1 === props.idUsuario &&
      (partida.partidaValidadaUsuario1 === false ||
        partida.partidaValidadaUsuario1 === null) &&
      partida.partidaValidadaUsuario2 === true
    ) {
      return true;
    } else if (
      partida.idCapitan2 === props.idUsuario &&
      (partida.partidaValidadaUsuario2 === false ||
        partida.partidaValidadaUsuario2 === null) &&
      partida.partidaValidadaUsuario1 === true
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    if (
      partida.idUsuario1 === props.idUsuario &&
      (partida.partidaValidadaUsuario1 === false ||
        partida.partidaValidadaUsuario1 === null) &&
      partida.partidaValidadaUsuario2 === true
    ) {
      return true;
    } else if (
      partida.idUsuario2 === props.idUsuario &&
      (partida.partidaValidadaUsuario2 === false ||
        partida.partidaValidadaUsuario2 === null) &&
      partida.partidaValidadaUsuario1 === true
    ) {
      return true;
    } else {
      return false;
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: modelValueProxy.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValueProxy).value = $event)),
    "max-width": "500"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "headline" }, {
            default: _withCtx(() => [
              _createTextVNode("Partidas de hoy")
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (__props.estaJugando.partidas && __props.estaJugando.partidas.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partidasOrdenadas.value, (partida, idx) => {
                      return (_openBlock(), _createBlock(CardPartidaGestion, {
                        key: partida.idPartidaTorneo || idx,
                        partida: partida,
                        editable: false,
                        etiqueta: 
              esCopa.value
                ? _unref(etiquetaPartidaCopa)(partida, null, __props.estaJugando.rondasEliminatoria)
                : esLiga.value
                  ? `Jornada ${partida.numeroRonda}`
                  : etiquetaRonda(partida)
            ,
                        idJugador: __props.idUsuario,
                        meterResultado: editarPartidaPJ(partida),
                        soloValidar: soloValidarPJ(partida),
                        listaPorPareja: __props.estaJugando.listaPorPareja === true,
                        cambiarPairing: __props.estaJugando.torneoType !== 'Individual'
                      }, null, 8, ["partida", "etiqueta", "idJugador", "meterResultado", "soloValidar", "listaPorPareja", "cambiarPairing"]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, "No tienes partidas activas."))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "tonal",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cerrar")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})